import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updatePassword } from '../../Api/authApi.js.js';
import { toast } from 'react-toastify';
import '../updateuser/updateuser.css';

const UpdatePassword2 = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth.user);

    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');

    const handleSubmit = async () => {
        if (password !== passwordConfirmation) {
            toast.warning('Les mots de passe ne correspondent pas.');
            return;
        }
        try {
            const data = await updatePassword(user.id, password, passwordConfirmation);
            toast.success(data.message);
            navigate('/profil');
        } catch (error) {
            toast.warning(error.message);
        }
    };

    const LockIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
    );

    return (
        <div className="settings-form-page">
            <div className="sfp-header">
                <button className="sfp-back-btn pill-tap" onClick={() => navigate('/profil')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <span className="sfp-page-title">Modifier le mot de passe</span>
            </div>

            <div className="sfp-body">
                <p className="sfp-subtitle">Choisis un nouveau mot de passe sécurisé</p>

                <div className="sfp-card relief">
                    <div className="sfp-field">
                        <span className="sfp-field-icon"><LockIcon /></span>
                        <input
                            className="sfp-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Nouveau mot de passe"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="sfp-field">
                        <span className="sfp-field-icon"><LockIcon /></span>
                        <input
                            className="sfp-input"
                            type="password"
                            value={passwordConfirmation}
                            onChange={(e) => setPasswordConfirmation(e.target.value)}
                            placeholder="Confirmer le mot de passe"
                            autoComplete="new-password"
                            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                        />
                    </div>

                    <button className="sfp-submit pill-tap" onClick={handleSubmit}>
                        Confirmer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdatePassword2;
